/* ============================================================
   Cupido's Drops — global JS
   reveal on scroll · sticky header · mobile nav · sticky CTA
   bar · shipping countdown
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Reveal on scroll (.rv) ---------- */
  var rvEls = document.querySelectorAll('.rv');
  if (rvEls.length) {
    if ('IntersectionObserver' in window) {
      var rvObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              rvObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      rvEls.forEach(function (el) {
        rvObserver.observe(el);
      });
    } else {
      rvEls.forEach(function (el) {
        el.classList.add('is-in');
      });
    }
  }

  /* ---------- Sticky header state ---------- */
  var header = document.querySelector('[data-cb-header]');
  if (header) {
    var onHeaderScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onHeaderScroll();
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
  }

  /* ---------- Mobile hamburger nav ---------- */
  var burger = document.querySelector('[data-cb-burger]');
  var nav = document.querySelector('[data-cb-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      burger.classList.toggle('is-open', isOpen);
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('cb-nav-locked', isOpen);
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('is-open');
        burger.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('cb-nav-locked');
      });
    });
  }

  /* ---------- Sticky bottom CTA bar ----------
     Visible only after the hero has left the viewport,
     hidden again while the pricing section is on screen. */
  var bar = document.querySelector('[data-cb-stickybar]');
  if (bar) {
    var hero = document.querySelector('[data-cb-hero]');
    var pricing = document.querySelector('[data-cb-pricing]');
    var heroGone = false;
    var pricingVisible = false;

    var updateBar = function () {
      bar.classList.toggle('is-visible', heroGone && !pricingVisible);
    };

    if ('IntersectionObserver' in window) {
      if (hero) {
        new IntersectionObserver(
          function (entries) {
            heroGone = !entries[0].isIntersecting;
            updateBar();
          },
          { threshold: 0 }
        ).observe(hero);
      } else {
        heroGone = true;
      }
      if (pricing) {
        new IntersectionObserver(
          function (entries) {
            pricingVisible = entries[0].isIntersecting;
            updateBar();
          },
          { threshold: 0 }
        ).observe(pricing);
      }
    } else {
      /* Fallback: show after one viewport of scrolling */
      var onBarScroll = function () {
        heroGone = window.scrollY > window.innerHeight;
        updateBar();
      };
      onBarScroll();
      window.addEventListener('scroll', onBarScroll, { passive: true });
    }
  }

  /* ---------- Countdown to next 4:00 PM local ---------- */
  var countdowns = document.querySelectorAll('[data-cb-countdown]');
  if (countdowns.length) {
    var pad = function (n) {
      return String(n).padStart(2, '0');
    };
    var tick = function () {
      var now = new Date();
      var cutoff = new Date(now.getTime());
      cutoff.setHours(16, 0, 0, 0);
      if (now >= cutoff) {
        cutoff.setDate(cutoff.getDate() + 1);
      }
      var diff = cutoff.getTime() - now.getTime();
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var label = h + 'h ' + pad(m) + 'm ' + pad(s) + 's';
      countdowns.forEach(function (el) {
        el.textContent = label;
      });
    };
    tick();
    setInterval(tick, 1000);
  }
})();
